import { Div, Image } from '@tblabs/truffle';
import { UploadIcon } from './Icons/UploadIcon';
import { RemoveIcon } from './RemoveIcon';
import { SelectableItem } from './SelectableItem';
import { SelectIcon } from './SelectIcon';
import { Snap } from '../../Models/Snap';
import { OcrIcon } from './Icons/OcrIcon';


export class SnapBox extends Div
{
    constructor(wrappedSnap: SelectableItem<Snap>)
    {
        super("snap-box");

        this.OnClick(() => wrappedSnap.SelfSelect());

        const snap = wrappedSnap.Item;

        const image = new Image(wrappedSnap.Item.Picture.Image).Class("snap-img");
        const selectBtn = new SelectIcon(snap.IsSelectedByUser);
        const removeBtn = new RemoveIcon().OnClick(() => wrappedSnap.RemoveSelf());
        const uploadBtn = new UploadIcon(snap.UploadState);
        const ocrBtn = new OcrIcon(snap);
        
        this.Append(
            image,
            selectBtn,
            removeBtn,
            uploadBtn,
            ocrBtn
        );

        this.When(wrappedSnap.IsSelected, v => v, 
            _ => this.AddClass("selected"), 
            _ => this.RemoveClass("selected"));
    }
}
